import '../../styles/opros.css';
function Opros (){
return (
<div className='body-text'>
<div className='texts'>
<br/>
<p className='texts-h1'>Опросник для технического задания на создание веб-приложения</p>
<p className='texts-h2'>1. Общая информация</p>
1.1. Название проекта:<br/>
1.2. Краткое описание проекта (1-2 предложения):<br/>
1.3. Цели и задачи проекта:<br/>
1.4. Целевая аудитория (кто будет пользоваться приложением):<br/>
1.5. Есть ли аналогичные решения на рынке? Если да, укажите примеры:<br/>
________________________________________<br/>
<p className='texts-h2'>2. Функциональные требования</p>
2.1. Основные функции приложения (например, регистрация, авторизация, поиск, оплата и т.д.):<br/>
2.2. Дополнительные функции (если есть):<br/>
2.3. Нужна ли интеграция с внешними сервисами (например, платежные системы, соцсети, API и т.д.)?<br/>
2.4. Нужен ли личный кабинет для пользователей?<br/>
2.5. Нужна ли админ-панель для управления контентом?<br/>
2.6. Какие роли пользователей будут в системе (например, администратор, модератор, пользователь)?<br/>
________________________________________<br/>
<p className='texts-h2'>3. Дизайн и интерфейс</p>
3.1. Есть ли готовый дизайн или прототип?<br/>
3.2. Нужно ли разработать дизайн с нуля?<br/>
3.3. Предпочтения по стилю (минимализм, корпоративный, яркий и т.д.):<br/>
3.4. Нужна ли адаптивная верстка под мобильные устройства?<br/>
3.5. Есть ли требования к анимациям или интерактивным элементам?<br/>
________________________________________<br/>
<p className='texts-h2'>4. Технические требования</p>
4.1. Предпочтительный стек технологий (если есть):<br/>
•	Frontend (например, React, Angular, Vue.js):<br/>
•	Backend (например, GO, Django, PHP):<br/>
•	База данных (например, MySQL, PostgreSQL, MongoDB):<br/>
4.2. Нужно ли использовать облачные сервисы (AWS, Google Cloud, Azure и т.д.)?<br/>
4.3. Требования к хостингу (если есть):<br/>
4.4. Нужна ли поддержка мультиязычности?<br/>
4.5. Требования к безопасности (например, SSL, двухфакторная аутентификация):<br/>
________________________________________<br/>
<p className='texts-h2'>5. Контент</p>
5.1. Кто будет заниматься наполнением контентом (тексты, изображения, видео)?<br/>
5.2. Есть ли готовый контент или его нужно создавать?<br/>
5.3. Нужна ли система управления контентом (CMS)?<br/>
________________________________________<br/>
<p className='texts-h2'>6. Сроки и бюджет</p>
6.1. Желаемые сроки запуска проекта:<br/>
6.2. Есть ли бюджетные ограничения?<br/>
6.3. Нужна ли пост-релизная поддержка и техническое обслуживание?<br/>
________________________________________<br/>
<p className='texts-h2'>7. Дополнительные вопросы</p>
7.1. Есть ли дополнительные пожелания или требования?<br/>
7.2. Кто будет ответственным за утверждение этапов работы?<br/>
7.3. Какой формат отчетности предпочтителен (например, еженедельные встречи, отчеты)?<br/>
________________________________________<br/>

Этот опросник поможет собрать всю необходимую информацию для составления технического задания на разработку веб-приложения.
<br/>
<br/>
</div>
</div> 
    );
}

export default Opros;